import {
  buildQueryByFacets,
  buildQueryPriceRange
} from "../../../../../../helpers/url";
import { getLocation } from "../../../../router/selectors";
import { getVisibleFacets, getSort } from "../../../selectors";
import {
  getNextPriceRange,
  isCurrentPriceRangeSelected,
  getPriceRangeState
} from "../../priceRange/selectors";
import { getSelectedPriceRangeFromRefineParam } from "../../priceRange/helpers/priceRangeUrl";

const getQueryIfNewSearch = state => {
  const sort = getSort(state);
  const facets = getVisibleFacets(state);
  const nextPriceRange = getNextPriceRange(state);
  const priceRangeState = getPriceRangeState(state);
  const { query } = getLocation(state);

  const selectedPriceRange = getSelectedPriceRangeFromRefineParam(
    query.refine || ""
  );
  const urlHasPriceFilter =
    Array.isArray(selectedPriceRange) &&
    selectedPriceRange.length === 2 &&
    selectedPriceRange.every(Number.isFinite);
  const hasSelectedValues =
    isCurrentPriceRangeSelected(state) || urlHasPriceFilter;

  const newRefine = buildQueryByFacets(facets, {
    ...nextPriceRange,
    hasSelectedValues
  });
  const newPriceRange = buildQueryPriceRange(priceRangeState);

  const shouldUpdate =
    newRefine !== query.refine ||
    newPriceRange !== query.currentpricerange ||
    sort !== query.sort;

  const next = shouldUpdate
    ? {
        query: {
          refine: newRefine,
          currentpricerange: newPriceRange,
          page: undefined,
          sort
        },
        priceRange: nextPriceRange
      }
    : undefined;

  return {
    next,
    shouldUpdate
  };
};

export default getQueryIfNewSearch;
